module.exports = __webpack_public_path__ + "static/media/image-polaroid.16650577.svg";